<template>
  <div class="popup" id="popup">
    <div class="popup__content popup--animate">
      <div class="popup__header">
        <svg class="popup__icon">
          <use href="@/assets/sprite.svg#icon-user"></use>
        </svg>
        <h1 class="heading-tertiary">{{ $t('popup.user.edit.title') }}</h1>
      </div>
      <div class='popup__form'>
        <form @submit.prevent="editUser" class="form" id="editUserForm">
          <div class="form__grouprow">
            <div class='userpopup__entry'>
              <Entry v-model="name" required indicator="form.name"></Entry>
              <Entry v-model="firstname" required indicator="form.firstname"></Entry>
              <Entry v-model="email" :maskOnValue='hasToBeAnEmail' indicator="form.email"></Entry>
              <Entry v-model="password" typeField='password' :maskOnValue='hasToBeAValidPassword' indicator="form.password"></Entry>
            </div>
            <div class="form__group u-margin-left-medium">
              <div class="userpopup__roles">
                <span class="userpopup__roles-label">Rôle(s)</span>
                <div class="userpopup__roles-list">
                  <div v-for="(role, index) in rolesList" :key="role._id">
                    <input class="userpopup__checkbox-button" type="checkbox" :value="role._id" :id="index" v-model="role.checked">
                    <label class="userpopup__checkbox-label u-pointer" :for="index">{{ role.name }}</label>
                  </div>
                </div>
              </div>
              <div class="form__group-indicator">
                <label class="form__label">
                  Sélectionnez au moins un rôle
                </label>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="popup__footer">
        <button class="popup__link u-pointer" type="button" form="editUserForm" @click='close'>{{ $t('popup.user.edit.cancelAction') }}</button>
        <button class="popup__link u-pointer" type="submit" form="editUserForm">{{ $t('popup.user.edit.confirmAction') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CLIENT } from '@/axios-wrapper'
import Entry from '@/components/Entry'
import { formMixin } from '@/components/Mixins/Form'
import { toastMixin } from '@/components/Mixins/Toast'

export default {
  data: function () {
    return {
      name: '',
      firstname: '',
      email: '',
      password: '',
      rolesList: []
    }
  },
  components: {
    Entry
  },
  mixins: [formMixin, toastMixin],
  props: ['user'],
  mounted: function () {
    this.getUserInfos()
    this.getRoles()
  },
  methods: {
    close () {
      this.$emit('popup:close')
      this.$store.commit('user/SHOW_EDIT_USER_POPUP', false)
    },
    getUserInfos () {
      const { email, name, firstname } = this.user

      this.name = name
      this.firstname = firstname
      this.email = email
    },
    async editUser () {
      if (this.$el.querySelectorAll('[data-entry-not-valid]').length) return

      this.setRoles()

      try {
        let data = {
          name: this.name,
          firstname: this.firstname,
          email: this.email
        }

        if (this.password.trim().length > 0) data.password = this.password
        await HTTP_CLIENT.patch(`user/${this.user._id}`, data)
        this.close()
        this.sendSuccessToast(this.$t('feedback-ok.user.edit', { firstname: this.firstname, name: this.name }))
      } catch (error) { console.log(error) }
    },
    async getRoles () {
      try {
        let { data } = await HTTP_CLIENT.get('groupAbility?sort=name')
        this.rolesList = data
        this.rolesList.forEach((role, idx) => {
          this.rolesList[idx].checked = false
          for (let id in this.user.groupAbilities) {
            if (this.user.groupAbilities[id] === role._id) {
              this.rolesList[idx].checked = true
              break
            }
          }
        })
      } catch (error) { console.log(error) }
    },
    async setRoles () {
      let roles = this.updateRoles
      console.log('roles to update', roles)
      try {
        await HTTP_CLIENT.put(`user/${this.user._id}/groupAbility`, {
          ids: roles
        })
      } catch (error) { console.log(error) }
    }
  },
  computed: {
    updateRoles () {
      return this.rolesList.filter(item => item.checked).map(id => id._id)
    }
  }
}
</script>
